import React from "react";

import IconButton from "@mui/joy/IconButton";
import {Modal, ModalClose, ModalDialog} from "@mui/joy";
import Box from "@mui/joy/Box";
import {Background, Controls, MiniMap, ReactFlow} from "reactflow";

// components
import BaseApi from "../../utils/BaseApi";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import SelfConnectingEdge from "../Admin/SelfConnectingEdge";
import FloatingConnectionLine from "../Admin/FloatingConnectionLine";
import {createGraph} from "../../utils/d3Force";
import RouteSimpleNode from "./RouteSimpleNode";

// icons
import AltRouteIcon from '@mui/icons-material/AltRoute';


const nodeTypes = {
    mainNode: RouteSimpleNode,
};

const edgeTypes = {
    selfconnecting: SelfConnectingEdge,
};


class RouteGraph extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            edges: null,
            nodes: null,
            isLoading: true,
            highlightedNode: null,
            modalOpen: false,
        };
    }

    async componentDidUpdate(prevProps,  prevState, snapShot){
    }

    async setModalOpenTrue(){
        const url = `route_stage/`;
        const api = new BaseApi();
        const params = {
            is_active: true,
            entity: this.props.entity,
        };
        let response = await api.get(url, params);
        let rawNodes = response.data.results.map((stage) => {
            return(
                {
                    id: stage.id,
                    position: {
                        x: stage.x_coordinate,
                        y: stage.y_coordinate,
                    },
                    data: {
                        label: stage.title,
                        obj: stage
                    },
                }
            )
            }
        );
        let rawEdges = [];
        for (let stage of response.data.results) {
            for (let edge of stage.next_stages) {
                rawEdges.push(
                    {
                        id: `${stage.id}-${edge.id}`,
                        source: stage.id,
                        target: edge.id,
                    }
                )
            }
        }
        const {formattedEdges, formattedNodes} = createGraph(
            rawEdges,
            rawNodes,
            this.highlightCallBack.bind(this)
        );
        await this.setState(
            {
                nodes: formattedNodes,
                edges: formattedEdges,
                modalOpen: true,
            }
        );
    }

    async setModalOpenFalse() {
        this.setState(
            {
                modalOpen: false,
            }
        )
    }

    highlightCallBack(id){
        if (id === this.state.highlightedNode){
            this.setState(
            {
                highlightedNode: null,
                edges: this.state.edges.map((edge) => {
                            edge.style = {stroke: 'white'}
                            return edge
                        }
                    )
                }
            );
        }
        else {
            let edges = this.state.edges.map((edge) => {
                if (edge.source === id.toString()){
                    edge.style = {stroke: 'yellow'}
                }
                else if (edge.target === id.toString()){
                    edge.style = {stroke: 'orange'}
                }
                else {
                    edge.style = {stroke: 'white'}
                }
                return edge
            });
            this.setState(
                {
                    highlightedNode: id,
                    edges: edges,
                }
            );
        }
    }

    render() {
        return(
            <Box
                sx={{
                    display: 'inline'
                }}
            >
                <IconButton
                    size={'sm'}
                    color="neutral"
                    onClick={this.setModalOpenTrue.bind(this)}
                >
                    <AltRouteIcon />
                </IconButton>
                <Modal
                    open={this.state.modalOpen}
                >
                    <ModalDialog
                        layout={'center'}
                        size="sm"
                    >
                        <ModalClose
                            onClick={this.setModalOpenFalse.bind(this)}
                        />
                        <Box
                            sx={{
                                width: 'calc(80vw)',
                                height: 'calc(80vh)',
                                pr: 2
                            }}
                        >
                            <ReactFlow
                                nodes={this.state.nodes}
                                edges={this.state.edges}
                                connectionLineComponent={FloatingConnectionLine}
                                //fitView
                                defaultViewport={{
                                    x: 0,
                                    y: 0,
                                    zoom: 0.1
                                }}
                                nodeTypes={nodeTypes}
                                edgeTypes={edgeTypes}
                            >
                                <Background />
                                <MiniMap
                                    pannable={true}
                                />
                                <Controls/>
                            </ReactFlow>
                        </Box>
                    </ModalDialog>
                </Modal>
            </Box>
        )
    }
}

export default RouteGraph